import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  user: {
    backgroundColor: theme.palette.primary.alt,
    padding: theme.spacing(2),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  profilePicture: {
    paddingBottom: "2rem",
  },
  displayName: {
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    fontSize: 40,
  },
  username: {
    color: theme.palette.primary.contrastText,
    fontSize: 20,
  },
  lastActive: {
    color: theme.palette.primary.contrastText,
    fontSize: 20,
    paddingBottom: theme.spacing(2),
  },
  request: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      boxShadow:
        "0 12px 16px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19)",
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  displayStats: {
    flexGrow: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  iconStyle: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  groupStyle: {
    paddingLeft: theme.spacing(1),
  },
  displayNameGroup: {
    display: "flex",
    flexDirection: "row",
  },
}));

export default useStyles;
